import actionCreatorFactory from 'typescript-fsa';

const actionCreator = actionCreatorFactory();

/** スキル情報 */
export interface ISkill {
	aplType: string; // 申請種別
	compulsoryID: string; // 区分
	careerSubTitle: string; // サブ種別
	careerTitle: string; // スキル名
	contents: string; // ランク
	complDate: string; // 認定日
	skillType: string; // スキル種別
	testResult: string; // 得点
	jissiKikan: string; // 実施期間
	classTitle: string; // 実施期間名
	jissiStartDateODT: Date; // 実施期間開始日
	jissiEndDateODT: Date; // 実施期間終了日
	status: string; // ステータス
	target: string; // 対象者
	credit: string; // 単位
	organizer: string; // スキル管理者
	cost: string; // 費用(円)
	mousikomiKikan: string; // 申込期間
	careerID: string; // スキルID
	classID: string; // クラスID
	compulsoryCssClass: string; // 区分値cssClass
	outOfPeriodFlg: boolean; // 実施期間外フラグ
	assessmentExistFlg: boolean; // アセスメント存在可能フラグ
	assessmentAnswerFlg: boolean; // アセスメント回答可能フラグ
	statusOnGoingFlg: boolean; // 実施中フラグ
	validDate: string; // 有効期限
	sikkouFlg: string; // 失効フラグ
	imstatListStatusId: number; // ステータスId
	rankID: string; // ランクID
}

/** 実施中スキル情報 */
export interface IOnGoingSkill extends ISkill {
	appChangeOkFlg: boolean; // 申請変更可能フラグ（操作メニューに影響）
	appCancelOkFlg: boolean; // 申請取消可能フラグ（操作メニューに影響）
	lecCancelOkFlg: boolean; // 実施取消可能フラグ（操作メニューに影響）
	appResultOkFlg: boolean; // 実績申請可能フラグ（操作メニューに影響）
}

/** 実績スキル情報 */
export interface IResultSkill extends ISkill {
	seq: string; // シーケンス番号
	reasonCode: string; // 原因コード
	certificateUploadFlg: boolean; // 証明書アップロード可能フラグ（操作メニューに影響）
	certificateDispFlg: boolean; // 証明書表示可能フラグ（操作メニューに影響）
	assessMentResultDispFlg: boolean; // アセスメント回答結果表示可能フラグ（操作メニューに影響）
}

/** スキルマップ情報 */
export interface ISkillMap {
	compulsoryID: string; // 	区分
	careerSubTitle: string; // サブ種別
	cmtitle: string; // スキルマップ名
	organizer: string; // スキルマップ管理者(主催者)
	updateUserIDName: string; // 最終更新者
	updateDate: string; // 最終更新日時
	cmid: string; // スキルマップID
	compulsoryCssClass: string; // 区分値cssClass
	applyEndTime: string; // 利用停止日
}

/** 分野情報 */
export interface ICareerMapField {
	fieldID: string; // 分野ID
	fieldLevel: string; // 分野レベル
	fieldTitle: string; // 分野名
	parentFieldID: string; // 親分野ID
}

export interface ICareerMapFieldList {
	careerMapName: string; // スキルマップ名
	fieldlevelOne: ICareerMapField[]; // 分野1
	fieldlevelTwo: ICareerMapField[]; // 分野2
	fieldlevelThree: ICareerMapField[]; // 分野3
}

export interface ICellSubCareer {
	aplType: string; // 申請種別
	careerID: string; // スキルID
	classID: string; // クラスID
	careerTitle: string; // スキル名
	complDate: string; // 認定日
	validDate: string; // 有効期限
	compulsoryCssClass: string; // 区分値cssClass
	seq: string; // シーケンス番号
	reasonCode: string; // 原因コード
	status: string; // ステータス
	statusId: string; // ステータスID
	statusNum: number; // ステータス（数値）
	rankID: string; // ランクID
	rankName: string; // ランク
	isPriority: string; // 優先設定
	careerTypeID: string; // 種別ID
	careerType: string; // 種別
	outOfPeriodFlg: boolean; // 実施期間外フラグ
	appChangeOkFlg: boolean; // 申請変更可能フラグ（操作メニューに影響）
	appCancelOkFlg: boolean; // 申請取消可能フラグ（操作メニューに影響）
	lecCancelOkFlg: boolean; // 実施取消可能フラグ（操作メニューに影響）
	appResultOkFlg: boolean; // 実績申請可能フラグ（操作メニューに影響
	certificateUploadFlg: boolean; // 証明書アップロード可能フラグ（操作メニューに影響）
	certificateDispFlg: boolean; // 証明書表示可能フラグ（操作メニューに影響）
	assessMentResultDispFlg: boolean; // アセスメント回答結果表示可能フラグ（操作メニューに影響）
	referenceOkFlg: boolean; // 実績参照可能フラグ（操作メニューに影響）
	enqueteDispFlg: boolean; // アンケート回答可能フラグ（操作メニューに影響）
	taskReportOkFlg: boolean; // 課題提出可能フラグ（操作メニューに影響）
	appLectureOkFlg: boolean; // 受講申請可能フラグ（操作メニューに影響）
	retakeOkFlg: boolean; // 再申請可能フラグ（操作メニューに影響）
	testFlg: boolean; // テスト履歴表示フラグ
}

export interface ICareerMapCell {
	cellSubCareer: ICellSubCareer[];
	cmcID: string; // キャリアマップセルID
	contents: string; // 説明
	careerCount: string; // 条件数
	fieldID1: string; // 分野ID1
	fieldID2: string; // 分野ID1
	fieldID3: string; // 分野ID1
	fieldName1: string; // 分野1
	fieldName2: string; // 分野2
	fieldName3: string; // 分野3
	levelTitle: string; // レベル
	status: string; // 達成状況
	statusId: string; // ステータス
}

/** 実施中スキルマップ情報 */
// tslint:disable-next-line:no-empty-interface
export interface IOnGoingSkillMap extends ISkillMap {}

/** 実績スキルマップ情報 */
// tslint:disable-next-line:no-empty-interface
export interface IResultSkillMap extends ISkillMap {}

export const setOnGoingSkillSelectedColumns = actionCreator<{
	selectedColumns: number[];
}>('SET_ON_GOING_SKILL_SELECTED_COLUMNS');

export const setOnGoingSkillMapSelectedColumns = actionCreator<{
	selectedColumns: number[];
}>('SET_ON_GOING_SKILLMAP_SELECTED_COLUMNS');

export const setOnGoingSkillData = actionCreator<{
	skillData: IOnGoingSkill[];
}>('SET_ON_GOING_SKILL_DATA');

export const setOnGoingSkillMapData = actionCreator<{
	skillMapData: IOnGoingSkillMap[];
}>('SET_ON_GOING_SKILLMAP_DATA');

export const setResultSkillSelectedColumns = actionCreator<{
	selectedColumns: number[];
}>('SET_RESULT_SKILL_SELECTED_COLUMNS');

export const setResultSkillMapSelectedColumns = actionCreator<{
	selectedColumns: number[];
}>('SET_RESULT_SKILLMAP_SELECTED_COLUMNS');

export const setResultSkillData = actionCreator<{
	skillData: IResultSkill[];
}>('SET_RESULT_SKILL_DATA');

export const setResultSkillMapData = actionCreator<{
	skillMapData: IResultSkillMap[];
}>('SET_RESULT_SKILLMAP_DATA');

export const setCareerMapFieldList = actionCreator<{
	careerMapName: string; // スキルマップ名
	fieldlevelOne: ICareerMapField[];
	fieldlevelTwo: ICareerMapField[];
	fieldlevelThree: ICareerMapField[];
}>('SET_CAREERMAP_FIELD_LIST');

export const setCareerMapCellData = actionCreator<{
	careerMapCellList: ICareerMapCell[];
}>('SET_CAREER_MAP_CELL_DATA');



// WEBPACK FOOTER //
// ./src/actions/skill.ts